import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LocationFullType } from '../../../components/Location/config';

export enum LocationStorageKeys {
  DETECTED = 'location_detected',
  SELECTED = 'location_selected',
}

export interface LocationStoreState {
  isDetecting: boolean;
  lastPlaceId: string;
  detectedLocation: LocationFullType | null;
  selectedLocation: LocationFullType | null;
  lockedLocation: (LocationFullType & { seoLine: string }) | null;
}

const initiaSubjectsState: LocationStoreState = {
  isDetecting: true,
  lastPlaceId: '',
  detectedLocation: localStorage.getItem(LocationStorageKeys.DETECTED)
    ? JSON.parse(localStorage.getItem(LocationStorageKeys.DETECTED)!)
    : null,
  selectedLocation: localStorage.getItem(LocationStorageKeys.SELECTED)
    ? JSON.parse(localStorage.getItem(LocationStorageKeys.SELECTED)!)
    : null,
  lockedLocation: null,
};

export const locationSlice = createSlice({
  name: 'location',
  initialState: initiaSubjectsState,
  reducers: {
    setIsDetecting(state: LocationStoreState, action: PayloadAction<boolean>) {
      state.isDetecting = action.payload;
    },
    setLastPlaceId(state: LocationStoreState, action: PayloadAction<string>) {
      state.lastPlaceId = action.payload;
    },
    setDetectedLocation(
      state: LocationStoreState,
      action: PayloadAction<LocationFullType>
    ) {
      state.detectedLocation = action.payload;
      localStorage.setItem(
        LocationStorageKeys.DETECTED,
        JSON.stringify(action.payload)
      );
    },
    setSelectedLocation(
      state: LocationStoreState,
      action: PayloadAction<LocationFullType>
    ) {
      state.selectedLocation = action.payload;
      localStorage.setItem(
        LocationStorageKeys.SELECTED,
        JSON.stringify(action.payload)
      );
      state.lockedLocation = null; // reset
    },
    setLockedLocation(
      state: LocationStoreState,
      action: PayloadAction<{
        nearestActiveLocation: LocationFullType;
        nearestActiveLocationSeoLine: string;
      }>
    ) {
      state.lockedLocation = {
        ...action.payload.nearestActiveLocation,
        seoLine: action.payload.nearestActiveLocationSeoLine,
      };
    },
  },
});
